import axios from "axios";

export const uploadFileS3 = async ({
  file,
  presigned_url,
}: {
  file: File;
  presigned_url: string;
}) => await axios.put(presigned_url, file);
